// import { APIError } from 'lendsmart_js_sdk/lib/types';
// import {
//   UpdateAccountPayload,
//   Account
// } from 'lendsmart_js_sdk/lib/accounts';
import { ApiFieldError } from 'src/types';
import { Account } from 'src/types/Account';
import { actionCreatorFactory } from 'typescript-fsa';

export interface AccountId {
  accountId: string;
}

type APIError = ApiFieldError;

export type UpdateAccountPayload = Partial<Account>;

export type UpdateAccountParams = UpdateAccountPayload; // AccountId &

/**
 * Action Creators
 */
export const actionCreator = actionCreatorFactory(`@@manager/accounts`);

export const accountRequestStarted = actionCreator('request');

export const accountRequestSuccess = actionCreator<Account>('success');

export const accountRequestFail = actionCreator<APIError[]>('fail');

export const updateAccountActions = actionCreator.async<
  UpdateAccountParams,
  Account,
  APIError[]
>(`update`);
